import { FC } from "react"

import { ReactComponent as IconTrash } from "@common_assets/svg/trash.svg"
import { Fab } from "@mui/material"
import { useIsBreakpointUp } from "hooks/breakpoint"
import { useTranslation } from "react-i18next"

interface IProps {
  onClick: () => void
}

const FabDeleteButton: FC<IProps> = ({ onClick }) => {
  const isTablet = useIsBreakpointUp("tablet")
  const { t } = useTranslation()

  return (
    <Fab
      size="small"
      aria-label={t("students.removeStudentRow")}
      sx={{
        flexShrink: 0,
        alignSelf: isTablet ? "center" : "end",
      }}
      onClick={onClick}
    >
      <IconTrash />
    </Fab>
  )
}

export default FabDeleteButton
